var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.1298 8.58319L2.71097 10.1644L0.452148 10.842L1.1298 8.58319ZM1.1298 8.58319L7.8258 1.86248L9.4225 3.45989L2.71097 10.1644L1.1298 8.58319ZM10.2745 1.02389C10.3794 1.12877 10.4626 1.25329 10.5194 1.39033C10.5762 1.52738 10.6054 1.67426 10.6054 1.8226C10.6054 1.97094 10.5762 2.11782 10.5194 2.25487C10.4626 2.39191 10.3794 2.51643 10.2745 2.62131L9.95544 2.94107L8.35803 1.34366L8.67779 1.02389C8.88958 0.812249 9.17674 0.693359 9.47615 0.693359C9.77556 0.693359 10.0627 0.812249 10.2745 1.02389Z",
    fill: "#7783A1"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit_icon.e7f45ba3b9d8d3d403c4ed88f7bca0e2.svg";
export { ForwardRef as ReactComponent };